export default {
  waymarkHeader: 'waymark-header',
  activeBanner: 'active-banner',
};
